export default class {
  constructor() {
    this.host = 'https://api.contextine.com';
    this.clientId = 'atqpuunjg9ejrshqmuio9gpuvib27rkg.api.contextine.com';
    this.scopes = 'offline_access';
    this.clientSecret = 'K-50emOgCPfpF9m5exgm26C_'; // temporary until we move this to platform
  }

  _authUrl(redirect_uri, state) {
    return `${this.host}/authorize?scope=${this.scopes}&client_id=${
      this.clientId
    }&response_type=code&redirect_uri=${encodeURIComponent(
      redirect_uri,
    )}&state=${encodeURIComponent(state)}`;
  }

  _postUrl(token, channel, data) {
    return `${
      this.host
    }/api/chat.postMessage?token=${token}&channel=${channel}&text=${encodeURIComponent(data)}`;
  }

  _createCaseUrl() {
    return `${this.host}/api/v1/cases?sendUri=true`;
  }

  _refreshUrl() {
    return `${this.host}/oauth/token`;
  }

  refresh(refreshToken) {
    const payload = {
      refresh_token: refreshToken,
      client_id: this.clientId,
      client_secret: this.clientSecret,
      grant_type: 'refresh_token',
    };
    return fetch(this._refreshUrl(), {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).then((res) => {
      return res.json();
    });
  }

  createCase(token, _event, presignedUrls, snapshotBlobs, url) {
    const e = { ..._event };
    delete e.cameras;

    const event = {
      _eventid: _event.id,
      event: e,
      _fileList: presignedUrls,
      _callbackURI: url,
    };

    if (snapshotBlobs) {
      event.snapshots = snapshotBlobs;
    }

    return fetch(this._createCaseUrl(), {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(event),
    });
  }
}
